import { render, staticRenderFns } from "./LoadingShade.vue?vue&type=template&id=2c4a85eb&scoped=true"
import script from "./LoadingShade.vue?vue&type=script&lang=js"
export * from "./LoadingShade.vue?vue&type=script&lang=js"
import style0 from "./LoadingShade.vue?vue&type=style&index=0&id=2c4a85eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4a85eb",
  null
  
)

export default component.exports